import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from "../../../app/store";
import {globalFetchConfig, RequestStatus} from "../../../api/apiConfiguration";
import {BACKEND_URL} from "../../../configs";
import {NewVehicleDataConfigurationDTOVehicleTypeEnum} from "../../../api/generated";

export type VehicleTypesByManufacturer = { [manufacturer: string]: NewVehicleDataConfigurationDTOVehicleTypeEnum[] };

export const fetchManufacturerVehicleTypes = createAsyncThunk<VehicleTypesByManufacturer>(
    "manufacturerVehicleTypes/fetch",
    async () => {
        const response = await globalFetchConfig(`${BACKEND_URL}/api/private/franchise/new-vehicle/manufacturer-vehicle-types`, {
            method: "GET"
        });
        if (!response.ok) {
            throw new Error("Failed to fetch the vehicle types of new vehicle manufacturers");
        }
        return response.json();
    }
);

export interface ManufacturerVehicleTypesState {
    vehicleTypesByManufacturer: VehicleTypesByManufacturer;
    manufacturers: string[];
    requestStatus: RequestStatus;
}

const initialState: ManufacturerVehicleTypesState = {
    vehicleTypesByManufacturer: {},
    manufacturers: [],
    requestStatus: RequestStatus.NONE
};

export const manufacturerVehicleTypesSlice = createSlice({
    name: "manufacturerVehicleTypes",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchManufacturerVehicleTypes.pending, (state) => {
            state.requestStatus = RequestStatus.PENDING;
        });
        builder.addCase(fetchManufacturerVehicleTypes.fulfilled, (state, {payload}) => {
            state.vehicleTypesByManufacturer = payload;
            state.manufacturers = Object.keys(payload).sort((a, b) => a.localeCompare(b));
            state.requestStatus = RequestStatus.RESOLVED;
        });
        builder.addCase(fetchManufacturerVehicleTypes.rejected, (state) => {
            state.requestStatus = RequestStatus.REJECTED;
        });
    }
});

export const manufacturerVehicleTypesSelector = (state: RootState): VehicleTypesByManufacturer =>
    state.manufacturerVehicleTypes.vehicleTypesByManufacturer;

export const catalogManufacturersSelector = (state: RootState): string[] =>
    state.manufacturerVehicleTypes.manufacturers;

export const manufacturerVehicleTypesRequestStatusSelector = (state: RootState): RequestStatus =>
    state.manufacturerVehicleTypes.requestStatus;
